export const groupBy = function(xs, key, sumBy) {
  return xs.reduce(function(rv, _x) {
    const x = {..._x};
    if (rv[x[key]]) {
        x[sumBy] = rv[x[key]][sumBy] += x[sumBy];
        rv[x[key]] = x;
    } else {
        (rv[x[key]] = x || {});
    }
    return rv;
  }, {});
};


// WEBPACK FOOTER //
// ./src/helpers/object_util.js